import { PDP_SLIDER_SIZES } from "@/constants/index"

export const openModal = () => {}
let count = 0
export const openModalAction = (image, isVideo = "") => {
  console.log("called")
  document.body.classList.add("zoom-image-scroll")
  count++
  const element = document.querySelector(".product-detail-page")
  element?.classList.add("zoom-image-product-section")
  document.getElementById("imageoverlay").style.display = "block"
  if (count >= 3) {
    console.log("entry")
    const elementImage = document.querySelector("#imageoverlay")
    elementImage?.classList.add("zoom-activated")
  }

  document.body.classList.add("zoom-image-scroll")
  initZoomviewer(image, isVideo)
}
export const initZoomviewer = (assetID, isVideo = "") => {
  count++
  console.log("zoomInitCalled", assetID)
  const zoomViewer = new window.s7viewers.ZoomViewer()
  zoomViewer.setContainerId("s7viewer")
  zoomViewer.setParam("serverurl", "https://s7d1.scene7.com/is/image/")
  zoomViewer.setAsset(`PAWEB/${assetID}`)
  zoomViewer.init()
  console.log("zoomIni", zoomViewer)
  const zoomVideo = document.querySelector(".zoom-video")
  if (zoomVideo) {
    document.getElementById("zoomVideo").style.display = "none"
  }
  if (isVideo) {
    document.getElementById("s7viewer").style.display = "none"
  } else {
    if (zoomVideo) {
      document.getElementById("zoomVideo").style.display = "none"
    }
    document.getElementById("s7viewer").style.display = "block"
  }
  if (count >= 3) {
    const elementImage = document.querySelector("#imageoverlay")
    elementImage?.classList.add("zoom-activated")
  }
}

export const closeZoomImage = () => {
  const zoomVideo = document.querySelector(".zoom-video")
  if (zoomVideo) {
    document.getElementById("zoomVideo").style.display = "none"
  }
  document.body.classList.remove("zoom-image-scroll")
  const element = document.querySelector(".product-detail-page")
  element?.classList.remove("zoom-image-product-section")
  document.getElementById("imageoverlay").style.display = "none"
}

export const zoomVideoImage = () => {
  document.getElementById("s7viewer").style.display = "none"
  const zoomVideo = document.querySelector(".zoom-video")
  if (zoomVideo) {
    document.getElementById("zoomVideo").style.display = "block"
  }
}

export const getSlickSettings = width => {
  const { desktopSliderImages } = PDP_SLIDER_SIZES
  return {
    dots: false,
    slidesToShow: desktopSliderImages,
    slidesToScroll: 3,
    swipeToSlide: true,
    swipe: true,
    arrows: true,
    infinite: false,
    centerMode: false,
    centerPadding: "0px",
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4.95,
          focusOnSelect: false,
        },
      },
    ],
  }
}
